
import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import { BASE_URL, instanceAxios, convertDateFarsi } from "../../config";
import UploadControl from './FileUploadControl';
import CategoreItem from './CategoreItem';
import CategoreItemTemp from './CategoreItem';
export default function DownloaderField(props) {

    const [pic_Small_Address, setPic_Small_Address] = useState();
    const [pic_Big_Address, setPic_Big_Address] = useState();
    const [file_Address, setFile_Address] = useState();
    const [helpContext, setHelpContext] = useState();
    const [helpVideo, setHelpVideo] = useState();
    const [subject, setSubject] = useState('');
    const [titleUnderPic, setTitleUnderPic] = useState('');
    const [contextFile, setContextFile] = useState('');
    const [IsArchive, SetIsArchive] = useState(false);
    const [CreateDate, SetCreateDate] = useState('');
    const [CreatorName, SetCreatorName] = useState('');
    const [Count_Download, SetCount_Download] = useState(0);
    const [Count_Like, SetCount_Like] = useState(0);
    const [Count_Comment, SetCount_Comment] = useState(0);
    const [showModal, SetShowModal] = useState(false);
    const [showModalTemp, SetShowModalTemp] = useState(false);
    const [categoryData, SetCategoryData] = useState([]);
    const [categorySubjectData, SetCategorySubjectData] = useState([]);
    const [categoryId, SetcategoryId] = useState(0);
    const [categorySubjectId, SetcategorySubjectId] = useState(0);
    const [Wait, SetWait] = useState(false);
    const [TimeHelpVideo, SetTimeHelpVideo] = useState('');
    const [DownloadQuestion, SetDownloadQuestion] = useState(false);
    const [typeShow, SettypeShow] = useState(1);
    const [price, Setprice] = useState(0);
    const [LinkAddress, SetLinkAddress] = useState('');
    const [discountPercent, SetDiscountPercent] = useState(0);
    const [SoftAbility, setSoftAbility] = useState('');
    const [RequiredSpecifications, setRequiredSpecifications] = useState('');
    const [Isfavorites, SetIsfavorites] = useState('');
    const [AboutSoft, setAboutSoft] = useState('');
    const GetListData = async () => {
        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/DownloadFile.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'GetList_ById',
                Id: props.selectItemId
            })
        };
        await instanceAxios(config)
            .then(function (response) {
                if (response.status === 200) {
                    setPic_Small_Address(response.data[0].Pic_Small_Address);
                    setPic_Big_Address(response.data[0].Pic_Big_Address);
                    setSubject(response.data[0].Subject);
                    setTitleUnderPic(response.data[0].TitleUnderPic);
                    SetCreateDate(response.data[0].CreateDate);
                    SetCreatorName(response.data[0].Familly);
                    SetCount_Download(response.data[0].Count_Download === null ? "0" : response.data[0].Count_Download);
                    SetCount_Like(response.data[0].Count_Like === null ? "0" : response.data[0].Count_Like);
                    SetCount_Comment(response.data[0].Count_Comment);
                    SetcategoryId(response.data[0].categoryId);
                    SetcategorySubjectId(response.data[0].categorySubjectId);
                    SetTimeHelpVideo(response.data[0].TimeHelpVideo);
                    SetIsArchive(response.data[0].IsArchive === 1 ? true : false);
                    SetDownloadQuestion(response.data[0].DownloadQuestion === 1 ? true : false);
                    console.log("response.data[0].File_Address:::",response.data[0].File_Address);
                    setFile_Address(response.data[0].File_Address);
                    console.log("response.data[0].HelpContext:::", response.data[0].HelpContext);
                    setHelpContext(response.data[0].HelpContext);
                    console.log("response.data[0].HelpVideo:::", response.data[0].HelpVideo);
                    setHelpVideo(response.data[0].HelpVideo);
                    SettypeShow(response.data[0].typeShow);
                    Setprice(response.data[0].price);
                    SetLinkAddress(response.data[0].LinkAddress);
                    setSoftAbility(response.data[0].SoftAbility);
                    SetDiscountPercent(response.data[0].discountPercent);
                    setRequiredSpecifications(response.data[0].RequiredSpecifications);
                    SetIsfavorites(response.data[0].Isfavorites);
                    setAboutSoft(response.data[0].AboutSoft);
                }

            })
            .catch((err) => {

            })

    }
    const SaveInfo = async () => {

        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/DownloadFile.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'Insert',
                Subject: subject,
                Pic_Small_Address: pic_Small_Address,
                Pic_Big_Address: pic_Big_Address,
                TitleUnderPic: titleUnderPic,
                ContextFile: contextFile,
                Id: props.selectItemId,
                categoryId: categoryId,
                categorySubjectId: categorySubjectId,
                IsArchive: IsArchive ? "1" : "0",
                typeShow: typeShow,
                price: price,
                LinkAddress: LinkAddress,
                SoftAbility: SoftAbility,
                RequiredSpecifications: RequiredSpecifications,
                Isfavorites: Isfavorites,
                discountPercent: discountPercent,
                AboutSoft: AboutSoft,
            })

        };
        console.log("Isfavorites", Isfavorites);
        await instanceAxios(config)
            .then(function (response) {
                if (response.status === 200) {

                    if (props.selectItemId !== "") {
                        SaveHelpContext(props.selectItemId);
                        SaveHelpVideo(props.selectItemId);
                        SaveFileAddress(props.selectItemId);
                        toast.success("با موفقیت  ثبت شد");
                    }
                    else {
                        if (response.data.length !== 0) {
                            let _Id = response.data[0].Id;                            
                            SaveHelpContext(_Id);
                            SaveHelpVideo(_Id);
                            SaveFileAddress(_Id);
                        }

                    }
                    SetWait(false);
                    toast.success("با موفقیت ثبت شد");
                }
            })
            .catch((err) => {
                toast.warning(err.response ? 'بروز خطا' + err ?.response ?.data ?.msg : 'بروز خطا' + err.message, {
                    closeButton: false,
                    autoClose: 1500
                });
            })
    }

    const SaveFileAddress = async (value_Id) => {        
        if (file_Address === undefined)
            return;
       
        let A = JSON.parse(JSON.stringify(file_Address));
        let File_Address_Size = A[0] ?.file_size !== undefined ? A[0].file_size : "";
        let File_Address_filename = A[0] ?.file_name !== undefined ? A[0].file_name : "";
        let File_Address_filetype = A[0] ?.file_type !== undefined ? A[0].file_type : "";
        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/DownloadFile.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'InsertFile',
                File_Address: file_Address,
                File_Address_Size: File_Address_Size,
                File_Address_filename: File_Address_filename,
                File_Address_filetype: File_Address_filetype,
                DownloadQuestion: DownloadQuestion ? "1" : "0",
                Id: (value_Id !== "" && value_Id !== undefined) ? value_Id : props.selectItemId
            })
        };
        await instanceAxios(config)
            .then(function (response) {

            })
            .catch((err) => {
                toast.warning(err.response ? 'بروز خطا' + err ?.response ?.data ?.msg : 'بروز خطا' + err.message, {
                    closeButton: false,
                    autoClose: 1500
                });
            })

    }

    const SaveHelpContext = async (value_Id) => {

        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/DownloadFile.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'InsertFile',
                HelpContext: helpContext,
                Id: value_Id,
            })
        };
        await instanceAxios(config)
            .then(function (response) {

            })
            .catch((err) => {
                toast.warning(err.response ? 'بروز خطا' + err ?.response ?.data ?.msg : 'بروز خطا' + err.message, {
                    closeButton: false,
                    autoClose: 1500
                });
            })


    }

    const SaveHelpVideo = async (value_Id) => {

        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/DownloadFile.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'InsertFile',
                HelpVideo: helpVideo,
                TimeHelpVideo: TimeHelpVideo,
                Id: value_Id,
            })
        };
        await instanceAxios(config)
            .then(function (response) {
                if (response.status === 200) {


                }
            })
            .catch((err) => {
                toast.warning(err.response ? 'بروز خطا' + err ?.response ?.data ?.msg : 'بروز خطا' + err.message, {
                    closeButton: false,
                    autoClose: 1500
                });
            })

    }

    useEffect(() => {
        (props.selectItemId !== "" && props.selectItemId !== undefined) && GetListData()

    }, [props.selectItemId])


    return (
        <div className="row">
            <div className="col-lg-12 col-md-12 col-xs-12">
                <div className="box box-info">
                    <div className="box-header with-border">
                        <h3 className="box-title">ورود اطلاعات دانلودها</h3>
                        <div className="pull-left">
                            <button type="button" onClick={(e) => props.onSetshowField(0, '', '')} title="بازگشت" className="btn btn-default btn-sm" style={{ fontSize: "18px", backgroundColor: "#e6dcdc", marginLeft: "3px" }}><i className="icon ion-reply-all" ></i></button>
                        </div>
                    </div>

                    <form className="form-horizontal">
                        <div className="box-body">
                            {(props.selectItemId !== "" && props.selectItemId !== undefined) && <div className="form-group">
                                <label className="col-sm-2 control-label"></label>
                                <div className="col-lg-3 col-md-4 col-xs-12">
                                    <label className="control-label">تاریخ ثبت:</label>
                                    <label className="control-label" style={{ color: "orangered", marginRight: "10px" }}>{convertDateFarsi(new Date(CreateDate))}</label>

                                </div>
                                <div className="col-lg-3 col-md-4 col-xs-12">
                                    <label className=" control-label">کاربر ثبت کننده :</label>
                                    <label className=" control-label" style={{ color: "orangered", marginRight: "10px" }}>{CreatorName}</label>
                                </div>
                                <div className="col-lg-3 col-md-4 col-xs-12">

                                    <label className=" control-label">بایگانی شده :</label>
                                    <input type="checkbox" placeholder="" style={{ marginRight: "10px" }} checked={IsArchive ? "checked" : ""} value={IsArchive} onChange={(e) => SetIsArchive(e.target.checked)} />

                                </div>
                            </div>

                            }
                            {(props.selectItemId !== "" && props.selectItemId !== undefined) && <div className="form-group">
                                <label className="col-sm-2 control-label"></label>
                                <div className="col-lg-3 col-md-4 col-xs-12">
                                    <label className="control-label"> تعداد دانلود:</label>
                                    <label className="control-label" style={{ color: "orangered", marginRight: "10px" }}>{Count_Download}</label>

                                </div>
                                <div className="col-lg-3 col-md-4 col-xs-12">
                                    <label className=" control-label">تعداد لایک :</label>
                                    <label className=" control-label" style={{ color: "orangered", marginRight: "10px" }}>{Count_Like}</label>
                                </div>
                                <div className="col-lg-3 col-md-4 col-xs-12">

                                    <label className=" control-label">تعداد نظرات :</label>
                                    <label className=" control-label" style={{ color: "orangered", marginRight: "10px" }}>{Count_Comment}</label>

                                </div>
                            </div>

                            }
                            <div className="form-group">
                                <label className="col-sm-2 control-label">دسته بندی محتوایی:</label>
                                <div className="col-sm-4" >
                                    <div className="input-group input-group-sm">
                                        <select className="form-control" style={{ fontSize: "14px", fontFamily: "iransans" }} value={categoryId} onChange={(e) => SetcategoryId(e.target.value)}>
                                            <option selected="selected" value="0" style={{ fontSize: "12px", fontFamily: "tahoma" }}>بدون انتخاب</option>
                                            {
                                                categoryData.length !== 0 &&
                                                categoryData.map((item, i) => {
                                                    return <option value={item.Id} style={{ fontSize: "12px", fontFamily: "tahoma" }}>{item.fieldTitle}</option>
                                                })
                                            }
                                        </select>
                                        <button type="button" onClick={() => SetShowModal(true)} className="btn btn-default btn-sm" style={{ fontSize: "16px", backgroundColor: "#e6dcdc" }}>
                                            <i className="icon ion-navicon-round"></i>
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <CategoreItem showModal={showModal} SetShowModal={(e) => SetShowModal(e)} Title={"افزودن دسته بندی"} parentId={1} SetCategoryData={(e) => SetCategoryData(e)} CategoryData={showModal === true ? categoryData : []} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-sm-2 control-label">دسته بندی موضوعی:</label>
                                <div className="col-sm-4" >
                                    <div className="input-group input-group-sm">
                                        <select className="form-control" style={{ fontSize: "14px", fontFamily: "iransans" }} value={categorySubjectId} onChange={(e) => SetcategorySubjectId(e.target.value)}>
                                            <option selected="selected" value="0" style={{ fontSize: "12px", fontFamily: "tahoma" }}>بدون انتخاب</option>
                                            {
                                                categorySubjectData.length !== 0 &&
                                                categorySubjectData.map((item, i) => {
                                                    return <option value={item.Id} style={{ fontSize: "12px", fontFamily: "tahoma" }}>{item.fieldTitle}</option>
                                                })
                                            }
                                        </select>
                                        <button type="button" onClick={() => SetShowModalTemp(true)} className="btn btn-default btn-sm" style={{ fontSize: "16px", backgroundColor: "#e6dcdc" }}>
                                            <i className="icon ion-navicon-round"></i>
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <CategoreItemTemp showModal={showModalTemp} SetShowModal={(e) => SetShowModalTemp(e)} Title={"افزودن دسته بندی"} parentId={2} SetCategoryData={(e) => SetCategorySubjectData(e)} CategoryData={showModalTemp === true ? categorySubjectData : []} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-sm-2 control-label">نوع فایل:</label>

                                <div className="col-sm-10" style={{ display: "inline-flex" }}>
                                    <div className="checkbox icheck">

                                        <label style={{ marginRight: "20px" }} >
                                            <input type="radio" name="show" checked={typeShow === 1 ? "checked" : ""} onChange={() => SettypeShow(1)} />دانلود فایل
                                 </label>
                                    </div>
                                    <div className="checkbox icheck">

                                        <label style={{ marginRight: "20px" }} >
                                            <input type="radio" name="show" checked={typeShow === 2 ? "checked" : ""} onChange={() => SettypeShow(2)} /> بازکردن لینک
                                 </label>
                                    </div>
                                </div>
                            </div>
                            {typeShow === 2 && <div className="form-group">
                                <label className="col-sm-2 control-label">آدرس لینک:</label>

                                <div className="col-sm-10">
                                    <input style={{ fontSize: "14px", direction: "ltr" }} type="text" className="form-control" placeholder="" value={LinkAddress} onChange={(e) => SetLinkAddress(e.target.value)} />
                                </div>
                            </div>
                            }
                            <div className="form-group">
                                <label className="col-sm-2 control-label">قیمت :</label>

                                <div className="col-sm-10" style={{ display: "inline-flex" }}>
                                    <input type="text" className="form-control" style={{ width: "150px" }} placeholder="" value={price} onChange={(e) => Setprice(e.target.value)} />
                                    <label className="control-label" style={{ marginRight: "10px" }}>ریال</label>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-sm-2 control-label">درصد تخفیف :</label>
                                <div className="col-sm-10" style={{ display: "inline-flex" }}>
                                    <input type="text" className="form-control" style={{ width: "150px" }} placeholder="" value={discountPercent} onChange={(e) => SetDiscountPercent(e.target.value)} />
                                    <label className="control-label" style={{ marginRight: "10px" }}>درصد</label>
                                </div>

                            </div>

                            <div className="form-group">
                                <label className="col-sm-2 control-label">موضوع:</label>

                                <div className="col-sm-10">
                                    <input type="text" className="form-control" placeholder="" value={subject} onChange={(e) => setSubject(e.target.value)} />
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="col-sm-2 control-label">تصویر کوچک:</label>

                                <div className="col-sm-10">
                                    <UploadControl value={pic_Small_Address} onChange={e => setPic_Small_Address(e)} id={"Pic_Small"} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-sm-2 control-label">تصویر بزرگ:</label>

                                <div className="col-sm-10">
                                    <UploadControl value={pic_Big_Address} onChange={e => setPic_Big_Address(e)} id={"Pic_Big"} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-sm-2 control-label">متن زیر تصویر:</label>

                                <div className="col-sm-10">
                                    <input type="text" className="form-control" placeholder="" value={titleUnderPic} onChange={(e) => setTitleUnderPic(e.target.value)} />
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="col-sm-2 control-label">درباره نرم فزار:</label>
                                <div className="col-sm-10">
                                    <textarea type="text" className="form-control" placeholder="" value={AboutSoft} onChange={(e) => setAboutSoft(e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-sm-2 control-label">قابلیت های نر افزار:</label>

                                <div className="col-sm-10">
                                    <textarea type="text" className="form-control" placeholder="" value={SoftAbility} onChange={(e) => setSoftAbility(e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-sm-2 control-label">مشخصات مورد نیاز:</label>

                                <div className="col-sm-10">
                                    <textarea type="text" className="form-control" placeholder="" value={RequiredSpecifications} onChange={(e) => setRequiredSpecifications(e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-sm-2 control-label">فایل دانلود:</label>
                                <div className="col-sm-10">
                                    <UploadControl value={file_Address} onChange={e => setFile_Address(e)} id={"file_Address"} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-sm-2 control-label"> جز محبوب ترین ها:</label>
                                <div className="col-sm-10">
                                    <input type="checkbox" placeholder="" style={{ marginRight: "10px" }} checked={Isfavorites ? "checked" : ""} value={Isfavorites} onChange={(e) => SetIsfavorites(e.target.checked)} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-sm-2 control-label"> نیاز به تایید فایل دانلود:</label>
                                <div className="col-sm-10">
                                    <input type="checkbox" placeholder="" style={{ marginRight: "10px" }} checked={DownloadQuestion ? "checked" : ""} value={DownloadQuestion} onChange={(e) => SetDownloadQuestion(e.target.checked)} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-sm-2 control-label"> فایل راهنمای متنی:</label>
                                <div className="col-sm-10">
                                    <UploadControl value={helpContext} onChange={e => setHelpContext(e)} id={"helpContext"} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-sm-2 control-label">فایل راهنمای تصویری:</label>
                                <div className="col-sm-10">
                                    <UploadControl value={helpVideo} onChange={e => setHelpVideo(e)} id={"helpVideo"} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-sm-2 control-label">مدت زمان راهنمای تصویری:</label>
                                <div className="col-sm-10">
                                    <input type="text" style={{ width: "100px" }} className="form-control" placeholder="" value={TimeHelpVideo} onChange={(e) => SetTimeHelpVideo(e.target.value)} />
                                </div>
                            </div>
                        </div>

                        {Wait === false && <div className="box-footer" id="btnLine">
                            <button type="button" onClick={(e) => props.onSetshowField(0, '', '')} className="btn btn-danger" style={{ marginRight: "10px", fontSize: "14px", width: "80px" }}>انصراف</button>
                            <button type="button" onClick={(e) => SaveInfo()} className="btn btn-success pull-right" style={{ marginRight: "10px", fontSize: "14px", width: "80px" }}>
                                {props.selectItemId === "" ? 'ثبت' : 'ویرایش'}
                            </button>
                        </div>
                        }
                        {Wait === true && <div className="box-footer text-center" id="waitLine" >
                            <i className="fa fa-spinner fa-spin" aria-hidden="true" style={{ fontSize: "30px", color: "orangered" }}></i>
                        </div>
                        }
                    </form>
                </div>
            </div>

        </div>

    );
}